import { render, staticRenderFns } from "./FooterCard.vue?vue&type=template&id=2b7b9ada&scoped=true&"
import script from "./FooterCard.vue?vue&type=script&lang=js&"
export * from "./FooterCard.vue?vue&type=script&lang=js&"
import style0 from "./FooterCard.vue?vue&type=style&index=0&id=2b7b9ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7b9ada",
  null
  
)

export default component.exports